import { useAppStorage } from "@artis/sdk-react";
import { useCallback, useEffect, useState } from "react";

import { useFeatureFlags } from "../../context/flags";

const KEY = "fraction";

/** Divider fraction of the Scratchpad split, remembered per user in browser storage so reopening restores it. */
export function useScratchpadSize() {
  const [scratchpadFlag] = useFeatureFlags("scratchpad");
  const enabled = scratchpadFlag !== undefined;
  const storage = useAppStorage("scratchpad", "browser");
  const [fraction, setFraction] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    storage.get<number>(KEY).then((value) => {
      if (active && typeof value === "number") setFraction(value);
    });
    return () => {
      active = false;
    };
  }, [storage, enabled]);

  const save = useCallback(
    (value: number) => {
      if (!enabled) return;
      setFraction(value);
      void storage.set(KEY, value).catch(() => {});
    },
    [storage, enabled],
  );

  return { fraction, save };
}
